import { cn } from '@/utils';

interface HeaderProps {
  title: string;
  titleClass?: string;
  subTitle?: string;
  subtitleClass?: string;
}

export default function HeaderAndSub({ title, titleClass = '', subTitle, subtitleClass = '' }: HeaderProps) {
  return (
    <>
      <label className={cn('text-2xl font-semibold  text-gray-900 mb-2 tracking-tight', titleClass)}>{title}</label>
      <p className={cn('text-gray-500 py-2 tracking-tight', subtitleClass)}>{subTitle}</p>
    </>
  );
}
